export default __webpack_public_path__ + "static/media/icon_category-decorations.c7b8e1fd.svg";